import { useCallback } from 'react';

import classNames from 'classnames';

import { LINEAR } from './utilities/options';
import Step from './components/Step';
import StepIndicator from './components/StepIndicator';

import styles from './_index.module.scss';

export interface StepperProps {
  activeIndex: number;
  className?: string;
  navigationType?: 'linear' | 'non-linear';
  onChange?: (index: number) => void;
  steps: {
    isComplete?: boolean;
    isDisabled?: boolean;
    label: string;
  }[];
}

const Stepper = ({
  activeIndex,
  className,
  navigationType = LINEAR,
  onChange,
  steps,
  ...props
}: StepperProps) => {
  const handleSelect = useCallback((index: number) => {
    if ((navigationType === LINEAR && index >= activeIndex) || steps[index].isDisabled) {
      return;
    }
    if (onChange) {
      onChange(index);
    }
  }, []);

  return (
    <ol className={classNames(styles['stepper'], className)} {...props}>
      <StepIndicator
        activeIndex={activeIndex}
        navigationType={navigationType}
        totalSteps={steps.length}
      />
      {steps.map((step, index) => (
        <li key={`step-${index}`}>
          <Step
            activeIndex={activeIndex}
            index={index}
            isComplete={step.isComplete}
            isDisabled={(navigationType === LINEAR && index > activeIndex) || step.isDisabled}
            label={step.label}
            onClick={handleSelect}
          />
        </li>
      ))}
    </ol>
  );
};

export default Stepper;
